import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpEvent, HttpRequest, HttpResponse } from "@angular/common/http";
import { AppConfig } from "../../app-config";
import { Observable } from "rxjs";
import { saveAs } from "file-saver";
import { map, take, tap } from "rxjs/operators";
import { Source } from "@pienso/ingest-types/source.interface";
import { CorpusDataService } from "./corpus-data.service";

@Injectable({ providedIn: "root" })
export class SourceDataService {
  private http = inject(HttpClient);
  private config = inject(AppConfig);

  public static hydrateSource(source: Source): Source {
    source.createdAt = source.createdAt ? new Date(source.createdAt) : source.createdAt;
    source.updatedAt = source.updatedAt ? new Date(source.updatedAt) : source.updatedAt;
    if (source.corpuses) {
      source.corpuses.map((pif) => CorpusDataService.hydrateCorpus(pif));
    }
    return source;
  }

  uploadFile(file: File): Observable<{ file: File; event: HttpEvent<never | string> }> {
    const formData = new FormData();
    formData.append("UBQ-FILE", file, file.name);
    const req = new HttpRequest("POST", this.config.ingestApiEndpoint + "/source/upload", formData, {
      reportProgress: true,
    });
    return this.http.request<string>(req).pipe(map((event) => ({ file, event })));
  }

  downloadData(source: Source): Observable<HttpResponse<any>> {
    return this.http
      .get(this.config.ingestApiEndpoint + "/source/" + source.id + "/download", {
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        take(1),
        tap((response: HttpResponse<any>) => {
          if (response.ok) {
            let filename: string | null = source.givenName;
            if (!filename || !filename.trim().length) {
              filename = source.originalName;
            }
            const multer = JSON.parse(source.multer);
            if (multer.mimetype === "text/tab-separated-values" || multer.originalname.endsWith(".tsv")) {
              filename += ".tsv";
            } else if (multer.mimetype === "application/json" || multer.originalname.endsWith(".json")) {
              filename += ".json";
            } else if (multer.mimetype === "text/csv" || multer.originalname.endsWith(".csv")) {
              filename += ".csv";
            } else if (multer.mimetype === "application/zip" || multer.originalname.endsWith(".zip")) {
              filename += ".zip";
            }
            filename = filename.trim();
            saveAs(response.body, filename);
          }
        }),
      );
  }
}
